import { IconButton } from "@mui/material";
import { DataGrid, GridColumns, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { ArrowBackIos as ArrowBackIosIcon } from "@mui/icons-material";
import Layout from "components/Layout";
import { Colors } from "models/Colors";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import MutualFundController, { MutualFund } from "services/controllers/MutualFundController";

const CustomToolbar = (props: any) => {
	const { goBackFuncttion } = props
	return (
		<GridToolbarContainer>
			<IconButton onClick={goBackFuncttion} size="large">
				<ArrowBackIosIcon style={{ color: Colors.primary }} />
			</IconButton>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<GridToolbarDensitySelector />
			<GridToolbarExport />
		</GridToolbarContainer>
	);
}

export default function MutualFunds(props: { match: { params: { uid: string } } }) {
	const [mutualFundList, setMutualFundList] = useState<MutualFund[]>([])
	const [loading, setLoading] = useState<boolean>(true)
	const history = useHistory()
	const mutualFundController = new MutualFundController()
	const uid: string = props.match.params.uid


	const columns: GridColumns = [
		{ field: "id", headerName: "ID", width: 300 },
		{ field: "value", headerName: "Value", width: 200 },
	]

	const getMutualFund = useRef(() => { })

	useEffect(() => {
		const fetchData = () => {
			getMutualFund.current()
		}
		return fetchData()
	}, [])

	getMutualFund.current = async () => {
		mutualFundController.getMutualFund(uid, (data) => {
			setMutualFundList(data)
			if (loading)
				setLoading(false)
		})
	}
	return (
		<Layout id={2}>
			<div
				style={{
					height: "calc(100vh - 170px)",
					width: "100%"
				}}>
				<DataGrid
					components={{
						Toolbar: CustomToolbar,
					}}
					componentsProps={{
						toolbar: {
							goBackFuncttion: () => {
								history.push("/users")
							},
						}
					}}
					rows={mutualFundList}
					columns={columns}
					loading={loading} />
			</div>
		</Layout>
	)
}
